import { initWorkCardVideoPreviews } from './work-card-video-preview';

function initShowMore() {
  const wrapperList = document.querySelectorAll('.js-show-more');
  if (!wrapperList.length) return;

  const disabledClass = 'btn_disabled';

  for (let i = 0; i < wrapperList.length; i++) {
    const wrapper = wrapperList[i];

    wrapper.addEventListener('click', async (e) => {
      const btn = e.target.closest('.js-show-more-btn');
      if (!btn) return;

      e.preventDefault();//link

      const btnText = btn.textContent;
      const btnLoadingText = btn.getAttribute('data-loading-text');
      const url = btn.getAttribute('href');
      const removeList = wrapper.querySelectorAll('.js-show-more-remove');

      let isHistory = false;
      if (btn.hasAttribute('data-history') && 'true' === btn.getAttribute('data-history')) {
        isHistory = true;
      }

      btn.classList.add(disabledClass);
      btn.textContent = btnLoadingText;

      try {
        const response = await fetch(url, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        const data = await response.json();

        removeList.forEach(remove => remove.remove());

        wrapper.insertAdjacentHTML('beforeend', data.html);
        initWorkCardVideoPreviews(wrapper);

        if (isHistory) {
          history.pushState({}, document.title, url);
        }
      } catch (err) {
        btn.classList.remove(disabledClass);
        btn.textContent = btnText;
        alert('Произошла ошибка');
      }
    });
  }
}

export {initShowMore};
